import { Button, Form, Input } from 'antd';
import { EyeTwoTone, EyeInvisibleOutlined } from '@ant-design/icons';
import { Link, useLocation } from 'react-router-dom';
import { useState, useEffect } from 'react';
import axios from 'axios';
import { openNotification } from '../../utils';

const ForgotToNewPassword = () => {
    const [loading, setLoading] = useState<boolean>(false);
    const location = useLocation();
    const [email, setEmail] = useState<string>('');
    const [otp, setOtp] = useState<string>('');
    const [isPasswordChanged, setIsPasswordChanged] = useState<boolean>(false);

    useEffect(() => {
        const queryParams = new URLSearchParams(location.search);
        const emailParam = queryParams.get('email');
        if (emailParam) {
            setEmail(emailParam);
        }
    }, [location.search]);

    const onFinishOtpAndNewPassword = (values: { newPassword: string; confirmPassword: string }) => {
        setLoading(true);

        const userData = {
            otp: otp,
            newPassword: values.newPassword,
            email: email,
        };

        const apiUrl = process.env.REACT_APP_API_BASE_URL + '/auth/reset-password';

        const config = {
            method: 'post',
            maxBodyLength: Infinity,
            url: apiUrl,
            data: userData,
        };

        axios
            .request(config)
            .then((response: any) => {
                console.log(response);
                openNotification('success', 'Başarılı', 'Şifreniz başarıyla yenilendi. Giriş yapabilirsiniz.');
                setIsPasswordChanged(true);
                setTimeout(() => {
                    // navigate('/giris');
                    setLoading(false);
                }, 3000);
            })
            .catch((e: any) => {
                console.log(e);
                if (e.response && e.response.status === 400 && e.response.data.message === 'Validation failed') {
                    const validationErrors = e.response.data.validationError;
                    if (validationErrors.newPassword) {
                        openNotification('error', 'Başarısız', `Yeni şifreniz büyük harf, küçük harf, ve rakam içermelidir ve en az 8 karakter olmalıdır!`);
                    } else {
                        openNotification('error', 'Başarısız', 'Tek Kullanımlık Parolanız hatalı veya şifreniz güçsüz! Kontrol ederek tekrar deneyin.');
                    }
                } else {
                    openNotification('error', 'Başarısız', 'Girilen Tek Kullanımlık Parola Hatalı! Kontrol ederek tekrar deneyin.');
                }
                setLoading(false);
            });
    };

    return (
        <section>
            {isPasswordChanged ? (
                <>
                    <h2 className="auth-card-title">Şifreniz güncellendi</h2>
                    <p className="auth-card-description">Yeni şifrenizle güvenle giriş yapabilirsiniz.</p>
                </>
            ) : (
                <>
                    <h2 className="auth-card-title">Yeni Şifre Belirle</h2>
                    <p className="auth-card-description">
                        E-postanıza gelen tek kullanımlık parolayı ve yeni şifrenizi girin.
                    </p>
                    <Form className="auth-card-form" layout="vertical" onFinish={onFinishOtpAndNewPassword}>
                        <Form.Item
                            name="otp"
                            label="Tek Kullanımlık Parola"
                            rules={[{ required: true, message: 'Lütfen tek kullanımlık parolayı girin.' }]}
                        >
                            <Input.OTP
                                size="large"
                                length={6}
                                value={otp}
                                onChange={setOtp}
                                formatter={(str) => str.toUpperCase()}
                                className="otp-input"
                            />
                        </Form.Item>
                        <Form.Item
                            name="newPassword"
                            label="Yeni Şifre"
                            rules={[{ required: true, message: 'Lütfen yeni şifrenizi girin.' }]}
                        >
                            <Input.Password
                                size="large"
                                iconRender={(visible) => (visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />)}
                                className="form-input"
                                placeholder="Yeni şifre"
                            />
                        </Form.Item>
                        <Form.Item
                            name="confirmPassword"
                            dependencies={['newPassword']}
                            label="Yeni Şifre Tekrar"
                            rules={[
                                { required: true, message: 'Lütfen yeni şifrenizi tekrar girin.' },
                                ({ getFieldValue }) => ({
                                    validator(_, value) {
                                        if (!value || getFieldValue('newPassword') === value) {
                                            return Promise.resolve();
                                        }
                                        return Promise.reject(new Error('Şifreler eşleşmiyor!'));
                                    },
                                }),
                            ]}
                        >
                            <Input.Password
                                iconRender={(visible) => (visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />)}
                                className="form-input"
                                size="large"
                                placeholder="Yeni şifre tekrar"
                            />
                        </Form.Item>
                        <Form.Item>
                            <Button htmlType="submit" loading={loading} size="large" block type="primary">
                                Şifreyi Değiştir
                            </Button>
                        </Form.Item>
                    </Form>
                </>
            )}
            <p className="auth-card-footer">
                Şifrenizi biliyor musunuz? <Link to="/giris">Giriş Yap</Link>
            </p>
        </section>
    );
};

export default ForgotToNewPassword;
